import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarEyesStyle1 } from './Style1'
import { Style as AvatarEyesStyle2 } from './Style2'

export const NAME = 'eyes'
export const STYLES = {
  style1: AvatarEyesStyle1,
  style2: AvatarEyesStyle2
}
export const INLINE_STYLE = {
  width: '220%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-5%)'
}
export const AvatarEyes = ({ style = 'style1', color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}
